module.exports = __webpack_public_path__ + "static/media/masks.2ff792a5.png";